import { GRAY, PURPLE, BLUE, YELLOW, GREEN, RED, GRAY_TRANSLUCENT, WHITE_TRANSLUCENT, PURPLE_TRANSLUCENT } from './colors.js';
var CLASSIC_COLORS = {
  canvas: GRAY.L1,
  primary: PURPLE.L7,
  primary2: PURPLE.L5,
  primaryHover: PURPLE.L6,
  secondary: BLUE.L5,
  secondary2: BLUE.L4,
  accent: YELLOW.L4,
  success: GREEN.L5,
  warning: YELLOW.L5,
  danger: RED.L5,
  text: GRAY.L8,
  textSubtle: GRAY_TRANSLUCENT.L6,
  textDisabled: GRAY_TRANSLUCENT.L3,
  surface: 'white',
  surfaceHigh: WHITE_TRANSLUCENT.L9,
  surfaceLow: GRAY_TRANSLUCENT.L3,
  border: GRAY_TRANSLUCENT.L3,
  inputBackground: WHITE_TRANSLUCENT.L4,
  iconFill: GRAY_TRANSLUCENT.L7,
  hoverNeutralBackground: GRAY_TRANSLUCENT.L2,
  hoverPrimaryBackground: PURPLE_TRANSLUCENT.L1,
  selectedBackground: PURPLE_TRANSLUCENT.L2,
  disabledBackground: GRAY_TRANSLUCENT.L3,
  focusOutline: BLUE.L4
};
var DARK_COLORS = {
  canvas: GRAY.L9,
  primary: PURPLE.L3,
  primary2: PURPLE.L5,
  primaryHover: PURPLE.L4,
  secondary: BLUE.L5,
  secondary2: BLUE.L4,
  accent: YELLOW.L4,
  success: GREEN.L6,
  warning: YELLOW.L6,
  danger: RED.L6,
  text: WHITE_TRANSLUCENT.L9,
  textSubtle: WHITE_TRANSLUCENT.L6,
  textDisabled: GRAY_TRANSLUCENT.L4,
  surface: GRAY.L8,
  surfaceHigh: WHITE_TRANSLUCENT.L4,
  surfaceLow: GRAY_TRANSLUCENT.L4,
  border: WHITE_TRANSLUCENT.L4,
  inputBackground: WHITE_TRANSLUCENT.L1,
  iconFill: WHITE_TRANSLUCENT.L8,
  hoverNeutralBackground: WHITE_TRANSLUCENT.L3,
  hoverPrimaryBackground: PURPLE_TRANSLUCENT.L2,
  selectedBackground: PURPLE_TRANSLUCENT.L3,
  disabledBackground: WHITE_TRANSLUCENT.L4,
  focusOutline: BLUE.L4
};
export { CLASSIC_COLORS, DARK_COLORS };
